module.exports = __webpack_public_path__ + "img/sec-209-uanta.6939a6cb.svg";